import { render, staticRenderFns } from "./insertUser.vue?vue&type=template&id=0a546a58"
import script from "./insertUser.vue?vue&type=script&lang=js"
export * from "./insertUser.vue?vue&type=script&lang=js"
import style0 from "./insertUser.vue?vue&type=style&index=0&id=0a546a58&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports